"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../../../zustandStore");
const walletDetails_1 = require("../component/walletDetails");
const walletDetailsHeader_1 = __importDefault(require("./walletDetailsHeader"));
const WalletDetailsContainer = ({ children }) => {
    const { requestTitle } = (0, react_router_1.useLoaderData)();
    const { setHeaderName } = (0, zustandStore_1.useZustand)();
    (0, react_1.useEffect)(() => {
        setHeaderName(requestTitle || 'N/A');
    }, [requestTitle]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(walletDetailsHeader_1.default, {}), (0, jsx_runtime_1.jsx)(walletDetails_1.StyledContainer, { "data-testid": "wallet-details-container", children: children })] }));
};
exports.default = WalletDetailsContainer;
